import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel", "dot", "progress"];

  connect() {
    this.currentIndex = 0;
    this.switchTabs();
    this.interval = setInterval(() => this.nextTab(), 4000);
  }

  nextTab() {
    this.deactivateTab(this.currentIndex);
    this.currentIndex = (this.currentIndex + 1) % this.tabTargets.length;
    this.activateTab(this.currentIndex);
  }

  onTabClick(event) {
    clearInterval(this.interval);
    const clickedTab = event.currentTarget;
    this.currentIndex = parseInt(clickedTab.dataset.tabIndex, 10);
    this.switchTabs();
    this.interval = setInterval(() => this.nextTab(), 4000);
  }

  switchTabs() {
    this.tabTargets.forEach((tab, index) => {
      if (index === this.currentIndex) {
        this.activateTab(index);
      } else {
        this.deactivateTab(index);
      }
    });
  }

  activateTab(index) {
    const tab = this.tabTargets[index];
    const panel = this.panelTargets[index];
    const progress = this.progressTargets[index];
    const dot = this.dotTargets[index];

    tab.setAttribute("aria-selected", "true");
    tab.classList.remove("opacity-50");
    dot.classList.add("bg-forest-600");
    dot.classList.remove("bg-gray-200");
    panel.classList.remove("hidden");
    if (progress) {
      progress.style.transitionDuration = "4s";
      progress.classList.add("scale-y-100");
    }
  }

  deactivateTab(index) {
    const tab = this.tabTargets[index];
    const panel = this.panelTargets[index];
    const progress = this.progressTargets[index];
    const dot = this.dotTargets[index];

    tab.setAttribute("aria-selected", "false");
    tab.classList.add("opacity-50");
    dot.classList.remove("bg-forest-600");
    dot.classList.add("bg-gray-200");
    panel.classList.add("hidden");
    if (progress) {
      progress.style.transitionDuration = "0.4s";
      progress.classList.remove("scale-y-100");
    }
  }
}
